const environment = {
 baseUrl: import.meta.env.REACT_PUBLIC_URL ?? ``,
  apiHostUrl: import.meta.env.REACT_APP_API_URL ?? ``,
  websiteName: import.meta.env.REACT_APP_WEBSITE_NAME ?? ``,
  authUrl: import.meta.env.REACT_APP_AUTH_URL ?? ``,
  clientId: import.meta.env.REACT_APP_CLIENT_ID ?? ``,
  // Keycloak configuration
  keycloakUrl: import.meta.env.REACT_APP_KEYCLOAK_URL ?? ``,
  keycloakRealm: import.meta.env.REACT_APP_KEYCLOAK_REALM ?? ``,
  keycloakClientId: import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? ``,
};

export default environment;
